import type { Routes } from '@/types';
import { getAppDetail } from '@/utils/server/app';

const subFolder = ''; // has to start with slash e.g. /foo

const { title } = getAppDetail();

export const routes: Routes = {
  root: {
    id: 'root',
    title,
    pathname: `${subFolder}/`,
    pattern: `^${subFolder}/?$`,
  },
  myCourses: {
    id: 'myCourses',
    title: 'Meine Kurse',
    pathname: `${subFolder}/meine-kurse`,
    pattern: `^${subFolder}/meine-kurse/?$`,
  },
  myCourse: {
    id: 'myCourse',
    title: 'Meine Kurs',
    pathname: `${subFolder}/kurs/[courseSlug]`,
    pattern: `^${subFolder}/kurs/[^/]+/?$`,
  },
  myCourseTabs: {
    id: 'myCourseTabs',
    title: 'selectedCourseTitle',
    pathname: `${subFolder}/kurs/[courseSlug]/[tabId]`,
    pattern: `^${subFolder}/kurs/[^/]+/[^/]+/?$`,
  },
  myCourseLearn: {
    id: 'myCourseLearn',
    title: 'selectedChapterTitle',
    pathname: `${subFolder}/kurs/[courseSlug]/lernen/[chapterSlug]`,
    pattern: `^${subFolder}/kurs/[^/]+/lernen/[^/]+/?$`,
  },
  myCourseFlashcards: {
    id: 'myCourseFlashcards',
    title: 'selectedChapterTitle',
    pathname: `${subFolder}/kurs/[courseSlug]/karteikarten/[deckSlug]`,
    pattern: `^${subFolder}/kurs/[^/]+/karteikarten/[^/]+/?$`,
  },
  manageDashboard: {
    id: 'manageDashboard',
    title: 'Admin Panel',
    pathname: `${subFolder}/manage/dashboard`,
    pattern: `^${subFolder}/manage/dashboard/?$`,
  },
  notFound: {
    id: 'notFound',
    title: 'Nicht gefunden',
    pathname: `^${subFolder}/nicht-gefunden/?$`,
    pattern: `^${subFolder}/nicht-gefunden/?$`,
  },
};
